import { InlineText1, Paragraph3 } from '@cian/ui-kit/typography';
import { Input } from '@cian/ui-kit/input';
import { InputAdornment } from '@cian/ui-kit/inputAdornment';
import * as React from 'react';
import * as styles from './BetInput.desktop.css';
import { RaiseServiceLevelButtonContainer } from '../RaiseServiceLevelButton';

interface IBetInputDesktopProps {
  value: string;
  placeholder: string;
  error: string | null;
  message: string | null;
  onChange(e: React.ChangeEvent<HTMLInputElement>, value: string): void;
}

export const BetInputDesktop = ({ value, placeholder, error, message, onChange }: IBetInputDesktopProps) => {
  const rightAdornment = (
    <InputAdornment>
      <InlineText1 whiteSpace="nowrap">₽ в день</InlineText1>
    </InputAdornment>
  );

  return (
    <>
      <InlineText1 fontWeight="700">Ваша ставка</InlineText1>

      <div className={styles['form-wrapper']}>
        <div className={styles['input-wrapper']}>
          <Input
            value={value}
            invalid={!!error}
            type="number"
            size="M"
            rightAdornment={rightAdornment}
            placeholder={placeholder}
            maxWidth={280}
            onChange={onChange}
          />

          <div className={styles['raise-service-level-button']}>
            <RaiseServiceLevelButtonContainer />
          </div>
        </div>

        {error && (
          <div className={styles['message']}>
            <Paragraph3 color="error_100">{error}</Paragraph3>
          </div>
        )}

        {!error && message && (
          <div className={styles['message']}>
            <Paragraph3 color="success_100">{message}</Paragraph3>
          </div>
        )}
      </div>
    </>
  );
};
